<div class="members-country" (mouseover)="onMouseOver()" (mouseleave)="onMouseOut()">

  <a><img [src]="image"></a>

  <div class="country-name">{{('members.continents.'+continent) | transloco}}</div>
</div>
